<template>
    <div id="pricing_action_reason_modal" class="modal pricing-action-modal">
        <div class="modal-background pricing-action-backdrop"></div>
        <div class="modal-card pricing-action-card pricing-action-card--reason">
            <header class="modal-card-head pricing-action-head">
                <p class="modal-card-title pricing-action-title">Pricing Reason</p>
            </header>
            <section class="modal-card-body pricing-action-body">
                <div class="field">
                    <label class="pricing-action-label">Please provide a reason for different pricing:</label>
                    <div class="control">
                        <textarea 
                            v-model="localReason"
                            @input="updateReason"
                            class="pricing-action-textarea"
                            placeholder="e.g. Different unit of measure means price was too high/low">
                        </textarea>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot pricing-action-foot">
                <button class="pricing-action-button pricing-action-button--secondary" @click="doClose">
                    Cancel
                </button>
                <button class="pricing-action-button pricing-action-button--primary" :disabled="localReason == '' || localReason.length < 7"
                    @click="doUpdateReason">
                    Continue with my price and reason
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PricingActionReasonModal',
    props: {
        paReason: {
            type: String,
            required: false,
            default: ''
        }
    },
    data() {
        return {
            localReason: this.paReason
        };
    },
    methods: {
        updateReason() {
            this.$emit('update:paReason', this.localReason);
        },
        doClose() {
            this.$emit('doClose')
        },
        doUpdateReason() {
            this.$emit('doUpdateReason')
        }
    },
    watch: {
        paReason(newVal) {
            this.localReason = newVal;
        }
    }
}
</script>


<style scoped>
.pricing-action-modal {
    z-index: var(--shell-modal-z, 1090);
}

.pricing-action-backdrop {
    background: var(--color-surface-overlay);
    backdrop-filter: blur(2px);
}

.pricing-action-card {
    width: min(520px, calc(100vw - 32px));
    max-height: calc(100vh - 48px);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md);
    overflow: hidden;
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
    box-shadow: var(--shadow-xl);
}

.pricing-action-head,
.pricing-action-foot {
    background: var(--color-surface-canvas);
    border-color: var(--color-border-muted);
}

.pricing-action-head {
    padding: 1rem 1.25rem;
}

.pricing-action-title {
    color: var(--color-text-primary);
    font-size: 1.05rem;
    font-weight: 700;
}

.pricing-action-body {
    padding: 1rem 1.25rem 1.25rem;
    background: var(--color-surface-canvas);
    color: var(--color-text-primary);
}

.pricing-action-label {
    display: block;
    margin-bottom: 0.5rem;
    color: var(--color-text-secondary);
    font-weight: 700;
}

.pricing-action-textarea {
    width: 100%;
    min-height: 112px;
    padding: 0.7rem 0.8rem;
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    background: var(--color-surface-subtle);
    color: var(--color-text-primary);
    resize: vertical;
    box-shadow: none;
}

.pricing-action-textarea::placeholder {
    color: var(--color-text-muted);
}

.pricing-action-textarea:focus {
    outline: none;
    border-color: var(--color-border-accent-strong);
    box-shadow: var(--shadow-focus-brand);
}

.pricing-action-foot {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding: 1rem 1.25rem;
}

.pricing-action-button {
    min-height: 2.35rem;
    min-width: 9.5rem;
    padding: 0.45rem 0.85rem;
    border: 1px solid transparent;
    border-radius: var(--radius-sm);
    font-weight: 700;
    line-height: 1.2;
    transition:
        transform 0.15s ease,
        box-shadow 0.15s ease,
        background-color 0.15s ease,
        border-color 0.15s ease,
        opacity 0.15s ease;
}

.pricing-action-button:hover:not(:disabled),
.pricing-action-button:focus:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: var(--shadow-sm);
}

.pricing-action-button:focus {
    outline: none;
    box-shadow: var(--shadow-focus-brand);
}

.pricing-action-button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
    transform: none;
    box-shadow: none;
}

.pricing-action-button--primary {
    background: transparent;
    border-color: var(--color-brand-primary);
    color: var(--color-brand-primary);
}

.pricing-action-button--primary:disabled {
    color: var(--color-text-inverse);
    background: var(--color-border-default);
    border-color: var(--color-border-default);
}

.pricing-action-button--primary:hover,
.pricing-action-button--primary:focus {
    background: var(--color-brand-primary-soft, var(--color-accent-soft));
    border-color: var(--color-brand-primary);
    color: var(--color-brand-primary);
}

.pricing-action-button--secondary {
    background: var(--color-surface-subtle);
    border-color: var(--color-border-default);
    color: var(--color-text-primary);
}

.pricing-action-button--secondary:hover,
.pricing-action-button--secondary:focus {
    border-color: var(--color-border-accent-strong);
}

@media (max-width: 640px) {
    .pricing-action-foot {
        flex-direction: column-reverse;
    }

    .pricing-action-button {
        width: 100%;
    }
}
</style>
